export function validateDateRange(dateRange?: { validFrom: string; validTo: string }) {
    return (date: Date) => {
        if (!dateRange) return true;

        const validFromDate = new Date(dateRange.validFrom);
        validFromDate.setHours(0, 0, 0, 0);
        const validToDate = new Date(dateRange.validTo);
        validToDate.setHours(23, 59, 59, 999);

        return date >= validFromDate && date <= validToDate;
    };
}
